var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMisc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "36px",
    viewBox: "0 0 49 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "misc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "misc",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6, 13)",
    fill: "#535353"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4-Copy",
    cx: 32.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4-Copy-3",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4-Copy-2",
    cx: 18.5,
    cy: 4.5,
    r: 4.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc);
export default __webpack_public_path__ + "static/media/misc.33827b899acdd8f9e28533acfe3f5762.svg";
export { ForwardRef as ReactComponent };